import React, { lazy, Suspense } from 'react';

import Typography from 'antd/es/typography';
import Layout from 'antd/es/layout';

import Loader from '#shared/Loader';
import { updateCommunity } from '#resources/communityResource';
import { withJSONApiHandler } from '#hoc/withJSONApiHandler';
import { withS3DirectUpload } from '#hoc/withS3DirectUpload';

import './style';

const CommunityEditForm = lazy(() => import('#components/communities/EditForm'));

const { Text, Title } = Typography;
const { Content } = Layout;

class EditContainer extends React.Component {
  state = {
    community: this.props.community,
    fileList: []
  }

  setFileList = fileList => {
    this.setState({ fileList: [...fileList] })
  }

  onLogoChange = ({ fileList }) => {
    this.setFileList(fileList)
  }

  onRemoveLogo = file => {
    this.props.setDirectUploadParams('')

    const newFilesList = this.state.fileList.filter(f => f.uid !== file.uid)
    this.setFileList(newFilesList)
  }

  onFormSubmit = async values => {
    const { errorsHandledApiCall } = this.props
    const { community } = this.state

    const newCommunity = await errorsHandledApiCall({ id: community.id, ...values })

    this.setState({ community: newCommunity, fileList: [] })
  }

  render() {
    const { community } = this.state
    const { baseErrors, fieldErrors, directUploadRequest, directUploadParams } = this.props

    const uploadLogoProps = {
      fileList: this.state.fileList,
      customRequest: directUploadRequest,
      onRemoveLogo: this.onRemoveLogo,
      onLogoChange: this.onLogoChange
    }

    return (
      <Suspense fallback={<Loader />}>
        <Content className='community-edit' style={{ backgroundColor: 'inherit' }}>
          {baseErrors.map(error => <Alert message={error} type='error' showIcon closable />)}

          <div style={{ marginBottom: '24px' }}>
            <Title level={4}>Update community profile</ Title>
            <Text type='secondary'>Tell participants about yourself.</Text>
          </div>

          <div className='community-edit-form'>
            <CommunityEditForm
              initialValues={directUploadParams ? { ...community, logo: directUploadParams } : community}
              onFormSubmit={this.onFormSubmit}
              errors={fieldErrors}
              uploadLogoProps={uploadLogoProps}
            />
          </div>
        </Content>
      </Suspense>
    )
  }
}

export default withS3DirectUpload(withJSONApiHandler(EditContainer, updateCommunity))
